import { INavData } from '@coreui/angular-pro';

export const navItems: INavData[] = [
  {
    name: 'Inicio',
    url: '/home/dashboard',
    iconComponent: { name: 'cil-home' },
  },
  {
    name: 'Encuestas',
    url: '/home/survey',
    iconComponent: { name: 'cil-description' },
    
  },
  {
    name: 'Canjea tus puntos',
    url: '/home/reward',
    iconComponent: { name: 'cil-gift' },
  },
  {
    name: 'Descarga de estudios',
    url: '/home/studies',
    iconComponent: { name: 'cil-file' },
  },
  {
    name: 'Lista de usuarios',
    url: '/home/user',
    iconComponent: { name: 'cil-user' }
  },
  {
    name: 'Sorteos',
    url: '/home/giveaway',
    iconComponent: { name: 'cil-casino' }
  }
];

export const navClient: INavData[] = [
  {
    name: 'Inicio',
    url: '/home/dashboard',
    iconComponent: { name: 'cil-home' },
  },
  {
    name: 'Encuestas',
    url: '/home/survey',
    iconComponent: { name: 'cil-description' },
    
  },
  {
    name: 'Canjea tus puntos',
    url: '/home/reward',
    iconComponent: { name: 'cil-gift' },
  },
  {
    name: 'Descarga de estudios',
    url: '/home/studies',
    iconComponent: { name: 'cil-file' },
  }
];

export const navAdministrator: INavData[] = [
  {
    name: 'Encuestas',
    url: '/home/survey',
    iconComponent: { name: 'cil-description' },
    
  },
  {
    name: 'Premios',
    url: '/home/reward',
    iconComponent: { name: 'cil-gift' },
  },
  {
    name: 'Estudios',
    url: '/home/studies',
    iconComponent: { name: 'cil-file' },
  },
  {
    name: 'Lista de usuarios',
    url: '/home/user',
    iconComponent: { name: 'cil-user' }
  },
  {
    name: 'Sorteos',
    url: '/home/giveaway',
    iconComponent: { name: 'cil-casino' }
  }
]
